import { render } from "./EventCard.vue?vue&type=template&id=d9b938f4&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=d9b938f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d9b938f4"

export default script